module.exports = __webpack_public_path__ + "static/media/sdirlogo.a7164f79.svg";